<template>
    <section class="stories-section">
        <div class="container">
            <div class="row">
                <div class="col-3 col-sm-2 col-md-2 d-lg-none d-xl-none">
                    <div class="catalog-filter">
                        <button id="sidebar-toggle" class="d-flex" @click.prevent="toggleFilterAction($event)">

                            <span class="icon">

                                <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M0 2C0 1.44771 0.305269 1 0.681819 1H14.3182C14.6947 1 15 1.44771 15 2C15 2.55229 14.6947 3 14.3182 3H0.681819C0.305269 3 0 2.55229 0 2Z"
                                        fill="#2E76E4"/>
                                    <path
                                        d="M15 8C15 7.44771 14.6947 7 14.3182 7H0.681812C0.30525 7 0 7.44771 0 8C0 8.55229 0.30525 9 0.681812 9H14.3182C14.6947 9 15 8.55229 15 8Z"
                                        fill="#2E76E4"/>
                                    <circle cx="4" cy="2" r="2" fill="#2E76E4"/>
                                    <circle cx="4" cy="2" r="2" fill="#2E76E4"/>
                                    <circle r="2" transform="matrix(-1 0 0 1 11 8)" fill="#2E76E4"/>
                                    <circle r="2" transform="matrix(-1 0 0 1 11 8)" fill="#2E76E4"/>
                                    <circle cx="4" cy="2" r="1" fill="#2E76E4"/>
                                    <circle cx="4" cy="2" r="1" fill="white"/>
                                    <circle r="1" transform="matrix(-1 0 0 1 11 8)" fill="#2E76E4"/>
                                    <circle r="1" transform="matrix(-1 0 0 1 11 8)" fill="white"/>
                                </svg>

                            </span>
                            {{$store.getters.t('catalog_stories_filter')}}

                        </button>
                    </div>
                </div>
                <div class="col-9 col-sm-10 col-md-10 col-lg-12">
                    <story-line v-if="stories" :stories="stories"/>
                </div>
            </div>

        </div>
    </section>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
import StoryLine from "../StoryLine";

export default {
    name: "CatalogStories",
    components: {StoryLine},
    data() {
        return {
            stories: null
        };
    },
    computed: {

        ...mapGetters({sliceState: 'sliceByKey'}),

        toggleFilter() {
            return this.sliceState('toggleFilter')
        }
    },
    mounted() {
        this.getCatalogHistories();
    },
    methods: {
        ...mapMutations({setState: 'setterByKey'}),
        toggleFilterAction(e) {
            if (window.matchMedia("min-width: 992px").matches) return;
            this.setState({key: 'toggleFilter', data: true});
            document.body.classList.add('product-sidebar--open');
        },
        getCatalogHistories() {
            axios.get(`/api/histories/last-histories`, {params: {limit: 25}})
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        this.stories = response.data
                    }
                });
        },
    }
}
</script>

<style lang="scss" scoped>

.stories-section {
    position: relative;
    background: #fff;
    overflow: hidden;

    .catalog-filter {
        display: inline-flex;
        position: relative;
        align-items: center;
        padding: 10px 25px 10px 0;
        margin-right: 25px;
        background: #fff;
        z-index: 50;
        height: 100%;

        &::after {
            position: absolute;
            display: block;
            content: '';
            width: 1px;
            height: 30px;
            background: #E1E1E1;
            top: 50%;
            transform: translateY(-50%);
            right: 0;
        }

        button {
            flex-direction: column;
            border: none;
            background: none;
            box-shadow: none;
            text-align: center;
            font-size: 10px;
            color: #929292;

            .icon {
                width: 45px;
                height: 45px;
                border-radius: 50%;
                overflow: hidden;
                text-align: center;
                line-height: 45px;
                background: #EAF1FC;
                margin-bottom: 5px;
            }

        }

        @media screen and (min-width: 991px) {
            display: none;

        }


    }

    @media screen and (max-width: 991px) {
        .container {
            position: relative;

            &::before {
                display: block;
                content: '';
                position: absolute;
                right: calc(100% - 15px);
                background: #fff;
                top: 0;
                bottom: 0;
                width: 500px;
                z-index: 49;
            }


        }
    }

}


</style>
